import { useTranslation } from 'react-i18next';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];
  const getName = (name: { en: string; pl: string; es: string; fr: string }) =>
    name[lang as 'en' | 'pl' | 'es' | 'fr'] || name.en;

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
      <div className="flex flex-col items-center text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          {t('home.categoriesTitle')}
        </h2>
        <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">{t('home.categoriesSub')}</p>
      </div>

      <div className="mt-8 flex justify-center">
        <CategoryDropdown />
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {categories.map((c) => (
          <a
            key={c.slug}
            href={c.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-36 w-full overflow-hidden md:h-40">
              <img
                src={c.image}
                alt={getName(c.name)}
                title={`${getName(c.name)} — USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between px-3 py-3">
              <span className="whitespace-nowrap text-sm font-medium text-foreground-800">{getName(c.name)}</span>
              <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                <i className="ri-arrow-right-line text-base"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}